function Hero() {
    return ( 
        <div className="container text-center p-4 border-bottom" style={{"marginBottom":"6rem","marginTop":"4rem"}}>
            <h2 className="mb-4">Zerodha Products</h2>
            <h5 className="mb-4 text-muted">Sleek, modern, and intuitive trading platforms</h5>
            <p className="fs-5">Check out our <a href="/offerings" className="text-decoration-none">investment offerings<i class="fa-solid fa-arrow-right"></i></a></p>
        </div>
     );
}

export default Hero;